import {IWithDisabled} from 'models';
import React from 'react';
import {PillarSelect} from './PillarSelect';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IPillarMultiSelectProps extends IWithDisabled {}

export function PillarMultiSelect({disabled}: IPillarMultiSelectProps) {
  return (
    <PillarSelect
      label="JA Competency Categories"
      selectionType="multi"
      disabled={disabled}
      infoText={RESOURCE_FIELD_TOOLTIPS.jaCompetencyCategories}
    />
  );
}
